import { ThemeUICSSObject } from '@apia/theme';
import associations from './associations';
import visibilities from './visibilities';
/* IMPORT HERE */

const entity: ThemeUICSSObject = {
  associations,
  visibilities,
  /* PREPEND HERE */
};

export default entity;
